module.exports = __webpack_public_path__ + "img/virtual-store-logo-full.59e14be5.svg";